import React from 'react';
import { Box, Button } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type DossierLegalAnnoucementsFooterProps = {
    canAddLegalAnnoucement: boolean;
    handleAddLegalAnnoucement: () => void;
};

const DossierLegalAnnoucementsFooter: React.FunctionComponent<DossierLegalAnnoucementsFooterProps> =
    function (props) {
        const { canAddLegalAnnoucement, handleAddLegalAnnoucement } = props;

        const wrapperSx = {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
        };

        const textBtnSx = {
            fontWeight: 500,
            padding: '8px 20px',
            display: 'flex',
            columnGap: '4px',
            alignItems: 'center',
            color: 'primary.dark',
            ':hover': {
                color: 'primary.main',
            },
        };

        const addBtnIconSx = {
            lineHeight: 1,
            color: 'inherit',
        };

        return (
            <Box sx={wrapperSx}>
                {canAddLegalAnnoucement && (
                    <Button
                        onClick={handleAddLegalAnnoucement}
                        sx={textBtnSx}
                        variant="text"
                        key="add-formality-btn"
                    >
                        <FaOptionIcon
                            icon={['fas', 'plus']}
                            sx={addBtnIconSx}
                        />
                        Ajouter une annonce légale
                    </Button>
                )}
            </Box>
        );
    };

export default DossierLegalAnnoucementsFooter;
